module.exports = __webpack_public_path__ + "media/images/games/cs-go/background-602cc97912d2fd50b09c99f512e73b73.jpg";